/** Returns true if both dates are in the same day */
export function sameDay(d1, d2) {
    return (
        d1.hasSame(d2, 'day') &&
        d1.hasSame(d2, 'month') &&
        d1.hasSame(d2, 'year')
    );
}
